module.exports = __webpack_public_path__ + "img/aboutUs83.ed7d574d.png";